import Building from 'common/icons/Building';
import LocationArrowIcon from 'common/icons/LocationArrow';
import SearchIcon from 'common/icons/Search';
import _ from 'lodash';

import { LocationType } from 'evee-ui-common/enums';
import { storage } from 'evee-ui-common/services';
import { CURRENT_LOCATION } from 'evee-ui-common/utils';
import Plane from 'widgets/booking/LocationInput/DeliveryOptions/Icons/Plane';

export const getDefaultLocationOptions = () => {
  const geolocationAvailable = 'geolocation' in navigator;
  const current = geolocationAvailable ? CURRENT_LOCATION : undefined;

  let latestSearchOption;
  try {
    const latestSearch = storage.latestSearch.get();
    if (latestSearch) {
      latestSearchOption = { ...JSON.parse(latestSearch), icon: LocationType.searchHistory };
    }
  } catch {
    latestSearchOption = undefined;
  }

  return _.compact([current, latestSearchOption]);
};

export const getLocationOptionIcon = (icon) => {
  switch (icon) {
    case LocationType.searchHistory:
      return <SearchIcon />;

    case LocationType.current:
      return <LocationArrowIcon />;

    case LocationType.airport:
      return <Plane />;

    case LocationType.country:
    case LocationType.city:
    case LocationType.suburb:
      return <Building />;

    default:
      return null;
  }
};